import { render, staticRenderFns } from "./OrderRD.vue?vue&type=template&id=11cd503d"
import script from "./OrderRD.vue?vue&type=script&lang=js"
export * from "./OrderRD.vue?vue&type=script&lang=js"
import style0 from "./OrderRD.vue?vue&type=style&index=0&id=11cd503d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports